import "../../styles/StockPriceItem.css"
import { useNavigate } from "react-router-dom";
export const StockPriceItem = ({ company, current, previous, size }) => {
    const navigate = useNavigate();
    let mode = "none";
    if (current > previous) {
        mode = "increased";
    } else if (current < previous) {
        mode = "decreased";
    }
    let percent = 0;
    if (previous > 0) {
        percent = 100 * Math.abs((current - previous) / previous);
    }
    if (!company && !current && !previous) return <div></div>
    return (
        <div style={{ margin: "14px" }} >
            <div className={`stock-price-item-container-${size}`} onClick={() => {
                navigate(`/company/${company}`)
            }}>
                <img className={`stock-price-item-image-${size}`} src={`${process.env.REACT_APP_SERVER_URL}/image/${company}.png`} alt=""></img>
                <div className={`stock-price-item-price-details-mode-${mode}`}>
                    <p className="stock-price-item-company">{company.toUpperCase()}</p>
                    <p style={{ marginTop: "-10px" }}>{current.toFixed(2)}</p>
                    <p style={{ marginTop: "-15px", fontSize: "0.85rem" }}>{`${current > previous ? "+" : ""}${(current - previous).toFixed(2)} (${percent.toFixed(2)}%)`}</p>
                </div>
            </div>
        </div>
    )
}